import React from 'react';
import { useUserProfile } from '../../helper/UserProfile';
import { Link, useLocation } from 'react-router-dom';
import '../../stylesheets/dashboard.scss'
import '../../stylesheets/profile.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

function MobileProfile() {
  
  const { profile, loading } = useUserProfile();
  const location = useLocation();


    if (loading) return <div></div>;
    if (!profile) return <div>No profile found.</div>;

  return (
    <div>
        <div className="mob-flex">
          <Link to="/dashboard/profile" className={location.pathname === "/dashboard/profile" ? "mob-option-button active" : "mob-option-button"}>
              Profile
          </Link>
  
          <Link to="/dashboard/competencies" className={location.pathname === "/dashboard/competencies" ? "mob-option-button active" : "mob-option-button"}>
              Competencies
          </Link>
  
          <Link to={profile.revalidation_membership === false ? "/dashboard/signup" : "/dashboard/details"} className={location.pathname === "/dashboard/details" || location.pathname === "dashboard/signup" ? "mob-option-button active" : "mob-option-button"}>
              {profile.revalidation_membership === false ? <FontAwesomeIcon icon={faLock} style={{paddingRight: "5px", fontSize: "10px"}}/> : ""}Revalidation
          </Link>
        </div>
    </div>
  );
}

export default MobileProfile;